import { Yup } from '@frontman/utils';

const separateInsurancePoliciesSchema = Yup.object()
  .shape({
    cancerInsurancePossessed: Yup.boolean(),
    accidentalDeathInsurancePossessed: Yup.boolean(),
    mortgageLifeInsurancePossessed: Yup.boolean(),
    accidentOrSicknessInsurancePossessed: Yup.boolean(),
    petInsurancePossessed: Yup.boolean(),
    homeWarrantyInsurancePossessed: Yup.boolean(),
    cellPhoneInsurancePossessed: Yup.boolean(),
    noneOfThese: Yup.boolean(),
  })
  .test(
    'at-least-one-selected',
    'At least one option must be selected',
    function (values) {
      const {
        cancerInsurancePossessed,
        accidentalDeathInsurancePossessed,
        mortgageLifeInsurancePossessed,
        accidentOrSicknessInsurancePossessed,
        petInsurancePossessed,
        homeWarrantyInsurancePossessed,
        cellPhoneInsurancePossessed,
        noneOfThese,
      } = values;

      const anySelected = [
        cancerInsurancePossessed,
        accidentalDeathInsurancePossessed,
        mortgageLifeInsurancePossessed,
        accidentOrSicknessInsurancePossessed,
        petInsurancePossessed,
        homeWarrantyInsurancePossessed,
        cellPhoneInsurancePossessed,
      ].some(Boolean);

      if (!anySelected && !noneOfThese) {
        return this.createError({
          message: 'At least one option must be selected',
          path: 'noneOfThese',
        });
      }

      return true;
    }
  );

export { separateInsurancePoliciesSchema };
